export default class ProductSubscriptions extends HTMLElement {
  constructor() {
    super();
    this.openButton = this.querySelector("[data-open-subscriptions]");
    this.subscriptionsList = this.querySelector("[data-subscriptions-list]");
    this.plans = this.querySelectorAll("input[name='plans']");
    this.subscribe = this.querySelectorAll("input[name='subscriptions']");
    this.atcButton = this.closest("form").querySelector("atc-button");
    this.productMainPrice = document.querySelectorAll(
      "[data-product-main-price]",
    );
    this.productMainPriceCompare = document.querySelectorAll(
      "[data-product-main-price-compare]",
    );
  }
  get sectionId() {
    return this.getAttribute("data-section-id");
  }

  connectedCallback() {
    this.handlePlanChange = this.handlePlanChange.bind(this);
    this.handleSubscribeChange = this.handleSubscribeChange.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);

    this.openButton.addEventListener(
      "click",
      this.openSubscriptions.bind(this),
    );

    this.plans.forEach((plan) => {
      plan.addEventListener("change", this.handlePlanChange);
    });
    this.subscribe.forEach((subscribe) => {
      subscribe.addEventListener("change", this.handleSubscribeChange);
    });

    document.addEventListener("click", this.handleDocumentClick);
  }
  handleDocumentClick(event) {
    const clickedOutsideList = !this.subscriptionsList.contains(event.target);
    const clickedOutsideButton = !this.openButton.contains(event.target);
    if (clickedOutsideList && clickedOutsideButton) {
      this.openButton.classList.remove("active");
      this.subscriptionsList.style.maxHeight = "0px";
    }
  }
  openSubscriptions() {
    this.openButton.classList.toggle("active");

    if (this.subscriptionsList.style.maxHeight === "0px") {
      this.subscriptionsList.style.maxHeight =
        this.subscriptionsList.scrollHeight + "px";
    } else {
      this.subscriptionsList.style.maxHeight = "0px";
    }
  }
  handleSubscribeChange(event) {
    const currentPlan = this.openButton.querySelector(
      "input[name='plans']",
    ).value;
    const quantity = document.querySelector(
      "#quantity-selector__value",
    ).textContent;

    const oneTimePrice = document.querySelector("[data-one-time-price]");
    const oneTimeComparePrice = document.querySelector(
      "[data-one-time-compare-price]",
    );
    const subscriptionPrice = document.querySelector(
      "[data-subscription-price]",
    );
    const subscriptionComparePrice = document.querySelector(
      "[data-subscription-compare-price]",
    );

    const productMainPrice = document.querySelectorAll(
      "[data-product-main-price]",
    );
    const productMainPriceCompare = document.querySelectorAll(
      "[data-product-main-price-compare]",
    );
    const mainPriceOff = document.querySelectorAll("[data-main-price-off]");
    const productPrice = document.querySelector("#product-price");
    const productPriceAll = document.querySelectorAll("[data-product-price]");

    if (event.target.value === "one_time") {
      this.atcButton.querySelector("input[name='selling_plan']").value = null;
      var url = new URL(window.location.href);
      url.searchParams.delete("selling_plan");
      window.history.replaceState(null, null, url);

      if (productPrice) {
        productPriceAll.forEach((price) => {
          price.innerHTML = Shopify.customFormatMoney(
            oneTimePrice.dataset.oneTimePrice * quantity,
            "{{amount}}",
          );
        });
        productPrice.dataset.productPrice = oneTimePrice.dataset.oneTimePrice;
      }

      productMainPrice.forEach((price) => {
        price.textContent = Shopify.customFormatMoney(
          oneTimePrice.dataset.oneTimePrice,
          "{{amount}}",
        );
      });

      if (oneTimeComparePrice) {
        productMainPriceCompare.forEach((price) => {
          price.textContent = Shopify.customFormatMoney(
            oneTimeComparePrice.dataset.oneTimeComparePrice,
            "{{amount}}",
          );
        });
      } else {
        productMainPriceCompare.forEach((price) => {
          price.textContent = "";
        });
      }
      mainPriceOff.forEach((price) => {
        price.style.display = "none";
      });
    } else {
      this.atcButton.querySelector("input[name='selling_plan']").value =
        currentPlan;
      this.updateURL(currentPlan);

      if (productPrice) {
        productPriceAll.forEach((price) => {
          price.innerHTML = Shopify.customFormatMoney(
            subscriptionPrice.dataset.subscriptionPrice * quantity,
            "{{amount}}",
          );
        });

        productPrice.dataset.productPrice =
          subscriptionPrice.dataset.subscriptionPrice;
      }

      productMainPrice.forEach((price) => {
        price.textContent = Shopify.customFormatMoney(
          subscriptionPrice.dataset.subscriptionPrice,
          "{{amount}}",
        );
      });
      if (subscriptionComparePrice) {
        productMainPriceCompare.forEach((price) => {
          price.textContent = Shopify.customFormatMoney(
            subscriptionComparePrice.dataset.subscriptionComparePrice,
            "{{amount}}",
          );
        });
      }
      mainPriceOff.forEach((price) => {
        price.style.display = "block";
      });
    }
  }
  handlePlanChange(event) {
    console.log("plan changed", event.target.value);
    this.atcButton.querySelector("input[name='selling_plan']").value =
      event.target.value;

    this.updateURL(event.target.value);
    this.updateSellingPlans(event.target.value);
    this.openButton.click();
  }

  updateURL(planId) {
    var url = new URL(window.location.href);
    url.searchParams.set("selling_plan", planId);
    window.history.replaceState(null, null, url);
  }

  updateSellingPlans(planId) {
    //check if the url has variant parameter
    const getUrl = new URL(window.location.href);
    let url = "";
    if (getUrl.searchParams.has("variant")) {
      const variantId = getUrl.searchParams.get("variant");
      url = `${window.location.pathname}?variant=${variantId}&selling_plan=${planId}&section_id=${this.sectionId}`;
    } else {
      url = `${window.location.pathname}?selling_plan=${planId}&section_id=${this.sectionId}`;
    }

    fetch(url)
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        const newContent = new DOMParser().parseFromString(data, "text/html");

        // Update Product Subscriptions Prices
        const newContentProductSubscriptions = newContent.querySelector(
          "#product-subscriptions",
        );

        document.querySelector("#product-subscriptions").innerHTML =
          newContentProductSubscriptions.innerHTML;

        // Update Product Atc Button
        const newContentProductAtcButton = newContent.querySelector(
          "#product-atc-button",
        );

        document.querySelector("#product-atc-button").innerHTML =
          newContentProductAtcButton.innerHTML;

        // Update Product Main Price
        const newContentProductMainPrice = newContent.querySelector(
          "[data-product-main-price-container]",
        );

        document
          .querySelectorAll("[data-product-main-price-container]")
          .forEach((price) => {
            price.innerHTML = newContentProductMainPrice.innerHTML;
          });

        // Update Product Sticky Price Container
        const newContentProductStickyPriceContainer = newContent.querySelector(
          "[data-product-sticky-price-container]",
        );

        document.querySelector(
          "[data-product-sticky-price-container]",
        ).innerHTML = newContentProductStickyPriceContainer.innerHTML;

        // Update Product Price
        const quantity = Number(
          document.querySelector("#quantity-selector__value").textContent,
        );
        const productPrice = document.querySelector("#product-price");
        const productPriceAll = document.querySelectorAll(
          "[data-product-price]",
        );

        productPriceAll.forEach((price) => {
          price.innerHTML = Shopify.customFormatMoney(
            productPrice.dataset.productPrice * quantity,
            "{{amount}}",
          );
        });
      })
      .catch((error) => {
        if (error.name !== "AbortError") {
          console.error("Error fetching variant:", error);
        }
      });
  }
}

customElements.define("product-subscriptions", ProductSubscriptions);
